import { Component } from '@angular/core';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-semantics-donut-bloom',
  templateUrl: './semantics-donut-bloom.component.html',
  styleUrl: './semantics-donut-bloom.component.scss',
})
export class SemanticsDonutBloomComponent {
  isLoading = true;

  options: echarts.EChartsOption = {
    legend: {
      orient: 'vertical',
      left: 'right',
      top: 'middle',
      type: 'scroll',
      height: 350, // or a percentage like '70%'
    },
    series: {
      center: ['44%', '50%'],
    },
  };

  constructor(protected analyticsService: AnalyticsService) {
    this.analyticsService.semanticsDonutBloom$.subscribe((data) => {});
    this.analyticsService.isLoading$.subscribe((loading) => {
      this.isLoading = loading.includes('semanticsDonutBloom');
    });
    this.getChartData();
  }

  getChartData() {
    this.analyticsService.getSemanticsDonutBloom().subscribe();
  }

  get series() {
    return this.analyticsService.semanticsDonutBloom$.value?.series[0];
  }

  get labels() {
    return this.analyticsService.semanticsDonutBloom$.value?.labels;
  }
}
